export default {
  Love: 22,
  Relationships: 21,
  SeriousRelationship: 1,
  Marriage: 19,
};
